import { createContext, useContext } from "react";
import type { ToolExperienceEvent } from "../../features/toolExperience/telemetry";
export const ToolEvents = createContext<
  ((event: ToolExperienceEvent) => void) | null
>(null);
export function useToolEvents() {
  return useContext(ToolEvents);
}
